import WatchManagementTable from './WatchManagementTable'

export default WatchManagementTable
